<template>
  <div id="recruit">
    <section id="title">
      <div class="en">Recruit</div>
      <div class="jp">採用情報</div>
      <div class="job-type">システム開発・Web制作</div>
      <div class="pic"></div>
      <div class="want">
        <div class="recruit-type">
          <span>【募集職種】</span>
        </div>
        <div class="status">
          <span>正社員</span>
        </div>
        <div class="job">
          <span>プログラマー</span>
        </div>
      </div>
      <div class="point">
        <span><font-awesome-icon icon="hand-point-right" />POINT</span>
        <ul>
          <li><font-awesome-icon icon="check" />学歴不問</li>
          <li><font-awesome-icon icon="check" />未経験歓迎</li>
          <li><font-awesome-icon icon="check" />年休130日以上</li>
          <li><font-awesome-icon icon="check" />月給25万〜80万円</li>
          <li><font-awesome-icon icon="check" />福利厚生充実</li>
        </ul>
      </div>
    </section>
    <section id="job-description">
      <div class="label">
        <span>仕事内容</span>
      </div>
      <div class="content">
        <span>ビットハイブは、とっても小さな会社です。メンバーは片手で数えられる程度です。本社オフィスビルは雑居ビルの中です。</span>
        <span class="br"/>
        <span class="br">研修期間中は、その本社オフィスでタッチタイピングの習得、Java言語と関連するフレームワークの習得、LinuxやGitのコマンド習得、HTML5やES6、CSS3等のフロントエンドテクノロジーを習得していただきます。</span>
        <span class="br"/>
        <span class="br">研修終了後は、当社メンバーが参画している、大手クライアントの金融システム開発プロジェクトへ参画していただき、設計や開発、テスト等の工程に携わっていただきます。</span>
        <span class="br"/>
        <span class="br">また、熟練度が上がるにつれ、プロジェクトリーダーやプロジェクトマネージャー、コンサルタント、アナリスト等を担当していただいたり、サービスの立ち上げ等をお任せするようになります。</span>
      </div>
    </section>
    <section id="desired-image">
      <div class="title">
        <span>求める人材像</span>
      </div>
      <div class="flex">
        <div class="content-wrapper">
          <div class="title">
            <span>チャレンジを楽しめる人</span>
          </div>
          <div class="content">
            <span>新しいことへのチャレンジは、成功をするための最初のプロセスです。</span>
            <span class="br"/>
            <span class="br">チャレンジに億劫な人は、どこかで失敗を恐れているのかもしれません。</span>
            <span class="br"/>
            <span class="br">失敗を恐れず、むしろ失敗をも楽む気持ちが大切です。</span>
            <span class="br"/>
            <span class="br"> 失敗こそ成功するための大切なプロセスなのです。</span>
            <span class="br"/>
            <span class="br">ビットハイブでは、新しいサービスの開発や最新技術を積極的に取り入れていきます。</span>
            <span class="br"/>
            <span class="br">そのため、新しいことへのチャレンジを楽しめる人を求めています。</span>
          </div>
        </div>
        <div class="content-wrapper">
          <div class="title">
            <span>恥ずかしいを捨てることができる人</span>
          </div>
          <div class="content">
            <span>恥ずかしいというのは、「自分がかっこ悪いと思われる」という恐怖心からやってくるものだと思っています。</span>
            <span class="br"/>
            <span class="br">恥ずかしいから、発言しない、行動しないよりも、恥ずかしがらずに発言したり、行動できる人はかっこ良いですよね。</span>
            <span class="br"/>
            <span class="br">ビットハイブでは、みんなで新しいアイディアを出し合ったり、ブレストしたりしてサービスを創っていきます。</span>
            <span class="br"/>
            <span class="br">そのため、恥を捨てて自分の考えやアイディアを発言したり、行動できる勇気ある人を求めています。</span>
          </div>
        </div>
        <div class="content-wrapper">
          <div class="title">
            <span>他人を尊重できる人</span>
          </div>
          <div class="content">
            <span>他人を尊重するということは、他人を認めたり許すことではなく、他人との違いを受け入れることです。</span>
            <span class="br"/>
            <span class="br">そもそも、人と人とは平等であるはずなのに、自分の価値観で人を上下に測ってしまいがちです。</span>
            <span class="br"/>
            <span class="br">他人を卑下してマウントを取ったり、他人のことを悪く言うような人がいると、チームは萎縮してしまいます。</span>
            <span class="br"/>
            <span class="br">ビットハイブでは、他人を是認や否定することなく、多様性を受け入れらる人を求めています。</span>
          </div>
        </div>
        <div class="content-wrapper">
          <div class="title">
            <span>自分から行動できる人</span>
          </div>
          <div class="content">
            <span>「指示されてないからやっていない。」「何故、指示していない事をやっているんだ。」</span>
            <span class="br"/>
            <span class="br">たまに耳にしますが、私はこの「指示」と言う言葉は、「自由」を奪っている感じがあり、好きではありません。</span>
            <span class="br"/>
            <span class="br">自由こそが、楽しいし、責任を要求するものであり、最高のパフォーマンスを発揮するものだと考えています。</span>
            <span class="br"/>
            <span class="br">自由の中で、自分が何をすべきかという役割を理解し、自分から当事者意識を持って行動できる人を求めています。</span>
          </div>
        </div>
      </div>
    </section>
    <section id="application-requirements">
      <div class="title">
        <span>募集要項</span>
      </div>
      <div class="table">
        <table>
          <tbody>
            <tr>
              <th>応募資格</th>
              <td>
                <span>20 〜 30歳位まで</span>
                <ul>
                  <li><font-awesome-icon icon="hand-point-right" />学歴を一切問いません。中卒の方の採用実績があります。</li>
                  <li><font-awesome-icon icon="hand-point-right" />未経験でも歓迎します。</li>
                </ul>
              </td>
            </tr>
            <tr>
              <th>雇用形態</th>
              <td>
                <span>正社員</span>
              </td>
            </tr>
            <tr>
              <th>応募職種</th>
              <td>
                <span>プログラマー</span>
                <ul>
                  <li><font-awesome-icon icon="hand-point-right" />金融系のプロジェクトが多いです。</li>
                </ul>
              </td>
            </tr>
            <tr>
              <th>給与</th>
              <td>
                <span>月給制 25 〜 80万円 ＋ 交通費 ＋ 時間外手当</span>
                <ul>
                  <li><font-awesome-icon icon="hand-point-right" />月給額はスキルや経験により決定します。</li>
                  <li><font-awesome-icon icon="hand-point-right" />査定は毎年3月です。</li>
                  <li><font-awesome-icon icon="hand-point-right" />未経験の方の研修期間中は月給20万円となります。（原則３ヶ月）</li>
                </ul>
              </td>
            </tr>
            <tr>
              <th>賞与</th>
              <td>
                <span>年2回（夏季/冬季）</span>
                <ul>
                  <li><font-awesome-icon icon="hand-point-right" />経験・業績・貢献に応じて当社規定により決定します。</li>
                </ul>
              </td>
            </tr>
            <tr>
              <th>福利厚生</th>
              <td>
                <ul>
                  <li><font-awesome-icon icon="hand-point-right" />交通費支給</li>
                  <li><font-awesome-icon icon="hand-point-right" />社会保険完備</li>
                  <li><font-awesome-icon icon="hand-point-right" />モニター、PC支給</li>
                  <li><font-awesome-icon icon="hand-point-right" />資格取得補助</li>
                  <li><font-awesome-icon icon="hand-point-right" />書籍購入補助</li>
                  <li><font-awesome-icon icon="hand-point-right" />セミナー参加補助</li>
                  <li><font-awesome-icon icon="hand-point-right" />交流会補助</li>
                  <li><font-awesome-icon icon="hand-point-right" />副業OK</li>
                  <li><font-awesome-icon icon="hand-point-right" />スープバー飲み放題（社内にスープバーを設置してます）</li>
                  <li><font-awesome-icon icon="hand-point-right" />ゲームやり放題（社内にNintendo Switchを設置しています）</li>
                  <li><font-awesome-icon icon="hand-point-right" />アニメ・映画見放題（社内にApple TVを設置しています）</li>
                </ul>
              </td>
            </tr>
            <tr>
              <th>勤務時間</th>
              <td>
                <span>基本勤務: 09:00 - 18:00</span>
                <span class="br">研修期間: 10:30 - 19:30</span>
                <ul>
                  <li><font-awesome-icon icon="hand-point-right" />勤務時間に1時間の休憩を含みます。</li>
                  <li><font-awesome-icon icon="hand-point-right" />業務の都合により、勤務時間の変更・時間外・深夜・休日勤務が発生する可能性があります。</li>
                </ul>
              </td>
            </tr>
            <tr>
              <th>勤務地</th>
              <td>
                <span>本社オフィス（東京都千代田区神田小川町1-9 川上ビル3F）</span>
                <span class="br">または担当のクライアント先オフィス（都心）</span>
              </td>
            </tr>
            <tr>
              <th>休日</th>
              <td>
                <span>土日祝祭日、国民の休日、有給休暇、夏季休暇、年末年始休暇、出産休暇、育児休暇、生理休暇</span>
                <ul>
                  <li><font-awesome-icon icon="hand-point-right" />年休130日以上。</li>
                </ul>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>
    <section id="flow-of-adoption">
      <div class="title">
        <span>採用までの流れ</span>
      </div>
      <div class="content">
        <ol>
          <li>
            <div>ご応募</div>
            <ol>
              <li>
                <div>Indeedまたは
                  <router-link :to="{ name: 'contact', params: {
                    value: 'contact',
                    from: 'recruit',
                  }}">お問い合わせフォーム</router-link>
                  からご応募ください。</div>
              </li>
              <li>
                <div>当社からメールにて会社説明会と面接の日程候補をご連絡差し上げます。</div>
              </li>
              <li>
                <div>日程候補の中からご都合の良い日程をメールにてご連絡ください。</div>
              </li>
            </ol>
          </li>
          <li>
            <div>会社説明会と面接</div>
            <ol>
              <li>
                <div>当社オフィスにて会社説明会を実施いたします。</div>
              </li>
              <li>
                <div>会社説明会が終わり次第、面接を実施いたします。</div>
              </li>
              <li>
                <div>当社よりメールにて面談の結果をご連絡させていただきます。</div>
              </li>
            </ol>
          </li>
          <li>
            <div>オファー通知と入社</div>
            <ol>
              <li>
                <div>当社より内定条件をご説明させていただきます。</div>
              </li>
              <li>
                <div>雇用契約の締結をさせていただきます。</div>
              </li>
              <li>
                <div>入社日を調整いたします。</div>
              </li>
            </ol>
          </li>
        </ol>
      </div>
    </section>
    <div class="button-area">
      <router-link :to="{ name: 'contact', params: {
                    value: 'contact',
                    from: 'recruit',
                  }}"><div>この募集に応募する</div></router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Recruit',
  mounted () {
    if (this.$route.params.value != null) {
      document.getElementById(this.$route.params.value).scrollIntoView()
      window.scrollBy(0, -58)
    }
  }
}
</script>

<style lang="scss">
@import "../assets/style/global.scss";

#recruit {
  letter-spacing: .15em;
  @media screen and (max-width: 1024px) {
    padding: 37px 20px;
  }
  @media screen and (min-width: 1025px) {
    padding: 37px 70px;
  }
  > #title {
    text-align: left;
    > .en {
      font-weight: 700;
      font-size: 28px;
      @media screen and (max-width: 1024px) {
        font-size: 28px;
      }
      @media screen and (min-width: 1025px) {
        font-size: 36px;
      }
    }
    > .jp {
      margin: 0 0 0 10px;
      @media screen and (max-width: 1024px) {
        font-size: 11px;
      }
      @media screen and (min-width: 1025px) {
        font-size: 12px;
        font-weight: 700;
      }
    }
    > .en, > .jp {
      display: inline-block;
    }
    > .job-type {
      font-weight: 700;
      @media screen and (max-width: 1024px) {
        font-size: 14px;
        margin: 10px 0 20px;
      }
      @media screen and (min-width: 1025px) {
        font-size: 18px;
        margin: 10px 0 40px;
      }
    }
    > .pic {
      background-image: url("../assets/img/recruit.png");
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
      width: 100%;
      height: auto;
      @media screen and (max-width: 1024px) {
        padding-top: 66%;
      }
      @media screen and (min-width: 1025px) {
        padding-top: 33%;
      }
    }
    > .want {
      font-weight: 700;
      padding: 7px 0 7px 10px;
      border-left-style: solid;
      @media screen and (max-width: 1024px) {
        margin: 20px 0;
        font-size: 14px;
      }
      @media screen and (min-width: 1025px) {
        margin: 60px 0;
        font-size: 22px;
      }
      > .status, > .job {
        display: inline-block;
      }
      > .status {
        background-color: limegreen;
        color: white;
        text-align: center;
        vertical-align: center;
        width: 80px;
        font-size: 11px;
        border: 1px solid limegreen;
        border-radius: 10px;
        margin: 10px 0 0 15px;
        @media screen and (max-width: 1024px) {
          font-size: 11px;
        }
        @media screen and (min-width: 1025px) {
          font-size: 14px;
        }
      }
      > .job {
        margin: 10px 0 0 0;
        vertical-align: center;
      }
    }
    > .point {
      > span {
        @media screen and (max-width: 1024px) {
          font-size: 16px;
        }
        @media screen and (min-width: 1025px) {
          font-size: 22px;
        }
        font-weight: 700;
        > svg {
          margin: 0 10px 0 0;
        }
      }
      > ul {
        list-style-type: none !important;
        padding-inline-start: 20px !important;
        > li {
          font-weight: 700;
          @media screen and (max-width: 1024px) {
            font-size: 14px;
          }
          @media screen and (min-width: 1025px) {
            font-size: 18px;
          }
          > svg {
            color: darkred;
            margin: 0 10px 0 0;
          }
        }
      }
    }
  }
  > #job-description {
    @media screen and (max-width: 1024px) {
      margin: 30px 0 0 0;
    }
    @media screen and (min-width: 1025px) {
      margin: 60px 0 0 0;
    }
    text-align: left;
    > .label > span {
      @media screen and (max-width: 1024px) {
        font-size: 16px;
      }
      @media screen and (min-width: 1025px) {
        font-size: 20px;
      }
      font-weight: 700;
    }
    > .content {
      @media screen and (max-width: 1024px) {
        font-size: 14px;
      }
      @media screen and (min-width: 1025px) {
        font-size: 16px;
      }
      text-align: justify;
      text-justify: inter-ideograph;
      line-height: 30px;
      margin: 10px 0;
    }
  }
  > #desired-image {
    text-align: left;
    margin: 50px 0;
    > .title {
      @media screen and (max-width: 1024px) {
        font-size: 16px;
      }
      @media screen and (min-width: 1025px) {
        font-size: 20px;
      }
      font-weight: 700;
      margin: 20px 0;
      padding: 7px 0 7px 10px;
      border-left-style: solid;
    }
    > .flex {
      @media screen and (max-width: 1024px) {
        display: block;
      }
      @media screen and (min-width: 1025px) {
        margin: 0 auto;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
      }
      > .content-wrapper {
        @media screen and (min-width: 1025px) {
          width: calc((100% - 15px) / 2);
          min-height: 300px;
        }
        border: 1px solid #000000;
        border-radius: 5px;
        padding: 20px;
        margin: 15px 0 0 0;
        > .title {
          @media screen and (max-width: 1024px) {
            font-size: 16px;
          }
          @media screen and (min-width: 1025px) {
            font-size: 18px;
          }
          font-weight: 700;
          margin: 0 0 20px 0;
        }
        > .content {
          @media screen and (max-width: 1024px) {
            font-size: 14px;
          }
          @media screen and (min-width: 1025px) {
            font-size: 16px;
          }
          text-align: justify;
          text-justify: inter-ideograph;
          line-height: 30px;
          margin: 10px 0;
        }
      }
    }
  }
  > #application-requirements {
    margin: 50px 0;
    text-align: left;
    font-size: 14px;
    > .title {
      @media screen and (max-width: 1024px) {
        font-size: 16px;
      }
      @media screen and (min-width: 1025px) {
        font-size: 20px;
      }
      font-weight: 700;
      margin: 20px 0;
      padding: 7px 0 7px 10px;
      border-left-style: solid;
    }
    > .table > table {
      width: 100%;
      border-collapse: collapse;
      border: 1px solid #333333;
      @media screen and (max-width: 1024px) {
        font-size: 14px;
      }
      @media screen and (min-width: 1025px) {
        font-size: 16px;
      }
      > tbody {
        > tr {
          border: 1px solid #333333;
          > th {
            width: 34%;
            text-align: center;
            padding: 15px 22px;
            background-color: #000;
            font-weight: 700;
            color: #fff;
          }
          > td {
            width: 66%;
            padding: 15px 10px;
            line-height: 30px;
            > span {
              font-weight: 700;
            }
            > ul {
              list-style-type: none !important;
              padding-inline-start: 20px !important;
              > li {
                margin: 15px 0;
                > svg {
                  margin: 0 10px 0 0;
                }
              }
            }
          }
        }
      }
    }
  }
  > #flow-of-adoption {
    margin: 50px 0;
    text-align: left;
    font-size: 14px;
    > .title {
      @media screen and (max-width: 1024px) {
        font-size: 16px;
      }
      @media screen and (min-width: 1025px) {
        font-size: 20px;
      }
      font-weight: 700;
      margin: 20px 0;
      padding: 7px 0 7px 10px;
      border-left-style: solid;
    }
    > .content {
      @media screen and (max-width: 1024px) {
        font-size: 14px;
      }
      @media screen and (min-width: 1025px) {
        font-size: 16px;
      }
      > ol {
        padding-inline-start: 30px !important;
        > li {
          line-height: 30px;
          margin: 30px 0 0 0;
          line-height: 30px;
          font-weight: 700;
          > ol {
            padding-inline-start: 20px !important;
            list-style-type: lower-roman;
            font-weight: normal !important;
            a {
              text-decoration: none;
              color: cornflowerblue;
            }
            a:hover {
              opacity: .6;
            }
          }
        }
      }
    }
  }
  > .button-area {
    text-align: center;
    display: block;
    margin: 20px 0;
    > a {
      text-decoration: none;
      > div {
        @media screen and (max-width: 1024px) {
          width: 100%;
        }
        @media screen and (min-width: 1025px) {
          width: 400px !important;
          margin: auto;
        }
        @media screen and (max-width: 1024px) {
          font-size: 14px;
          padding: 15px 0;
        }
        @media screen and (min-width: 1025px) {
          font-size: 18px;
          padding: 25px 0;
        }
        letter-spacing: .15em;
        cursor: pointer;
        background-color: #000;
        color: white;
        font-weight: 700;
        border: none;
        border-radius: 5px;
      }
    }
    > a > div:hover {
      opacity: .6;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Recruit.vue